module.exports = __webpack_public_path__ + "img/Arma 3 Unit Newfound Pioneer Corps Modpack step 1.507382f3.webp";